import request from '@/utils/request';

//人员管理列表
export function getCrowdList(param) {
  return request('/profile/queryGroupPage', {
    method: 'POST',
    data: param,
  });
}

//人群下载
export function groupDownloadMember(param) {
  return request('/profile/group/groupDownloadMember', {
    method: 'POST',
    data: param,
  });
}

//人群导出字段配置
export function queryGroupExportConfigList(param) {
  return request('/profile/group/queryGroupExportConfigList', {
    method: 'POST',
    data: param,
  });
}
